import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import QueuePlayNextIcon from "@mui/icons-material/QueuePlayNext";
import { useMaterialUIController } from "context";
import { useEffect, useState } from "react";

export default function CalcComponent(props) {
  const {
    question,
    disabled,
    editQuestionHandle,
    helpPage,
    headline,
    setFocuse,
  } = props;
  const [controller, dispatch] = useMaterialUIController();
  const [qText, setQText] = useState(question.useranswer);
  useEffect(() => {
    let text = question.useranswer;
    if (
      text.length == 10 &&
      text.includes("|") &&
      text.indexOf("|", 0) == 4 &&
      text.indexOf("|", 5) == 7
    ) {
      text = text.replace("|", "/").replace("|", "/");
      setQText(text);
    }
  }, []);
  return (
    <Grid
      item
      xs={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      sm={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      md={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      style={{
        position: question.fixTop || question.fixBottom ? "fixed" : "unset",
        left: question.fixTop || question.fixBottom ? 0 : "unset",
        right: question.fixTop || question.fixBottom ? 0 : "unset",
        top: question.fixTop ? 0 : "unset",
        bottom: question.fixBottom ? 0 : "unset",
        paddingBottom: question.fixTop || question.fixBottom ? 10 : "unset",
        backgroundColor:
          question.fixTop || question.fixBottom ? "#FFF" : "unset",
        zIndex: question.fixTop || question.fixBottom ? 999 : "unset",
        paddingTop: question.fixTop ? 55 : question.fixBottom ? 10 : "unset",
        paddingBottom: question.fixBottom ? 55 : question.fixTop ? 10 : "unset",
        paddingRight: question.fixTop || question.fixBottom ? 15 : "unset",
        paddingLeft: question.fixTop || question.fixBottom ? 15 : "unset",

        marginTop:
          question.titleType === 2 ? 8 : question.displayTitle ? 5 : 8,
        display:
          question.showForUser === true && question.visible ? "" : "none",
        paddingInlineEnd: question.size && question.size !== 12 ? 3 : "unset",
      }}
    >
      {question.titleType === 1 && question.displayTitle && (
        <b>{question.text}</b>
      )}
      <FormControl style={{ width: "100%" }} variant="outlined">
        {question.titleType === 2 && question.displayTitle === true && (
          <InputLabel htmlFor="outlined-adornment-password">
            {question.text}
          </InputLabel>
        )}
        <OutlinedInput
          multiline={true}
          minRows={1}
          // onTouchStart={() => {
          //   setFocuse();
          // }}
          // onMouseDown={() => {
          //   setFocuse();
          // }}
          onSelect={() => {
            setFocuse();
          }}
          readOnly={true}
          value={qText === "Invalid inputs" || qText === "" ? " " : qText}
          endAdornment={
            <InputAdornment>
              <IconButton disabled={true}>
                <QueuePlayNextIcon style={{ color: "#039dfc", height: 20 }} />
              </IconButton>
            </InputAdornment>
          }
          label={
            question.titleType === 2 && question.displayTitle == true
              ? question.text
              : null
          }
        />
      </FormControl>
    </Grid>
  );
}
